import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargingStationOutboundFormComponent } from './form.component';
import { ChargingStationOutboundFormService } from './form.service';
import { ChargingStationOutboundFormMapper } from './form.mapper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import ButtonModule from '../../../../component-lib/components/button/button-module';
import { CheckboxInputModule } from '../../../../component-lib/components/forms/checkbox-input/checkbox-input.module';
import { EmailInputModule } from '../../../../component-lib/components/forms/email-input/email-input.module';
import { TextInputModule } from '../../../../component-lib/components/forms/text-input/text-input.module';
import { LoadingModule } from '../../../../component-lib/components/loading/loading.module';
import { ModalModule } from '../../../../component-lib/components/modal/modal.module';

@NgModule({
  declarations: [ChargingStationOutboundFormComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    TextInputModule,
    EmailInputModule,
    CheckboxInputModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingModule,
  ],
  exports: [ChargingStationOutboundFormComponent],
  providers: [ChargingStationOutboundFormService, ChargingStationOutboundFormMapper],
})
export class ChargingStationOutboundFormModule {}
